export default class Booking implements be.Booking {
  edit: boolean = false;
  error: string = "";
  flags: {};
  itineraryId: string = "";
  contactInfo: be.ContactInfo = {};
  creditCards: be.TokenizedCreditCard[] = [];
  otherInfo: be.OtherInfo = {};
  passengerDetails: be.PassengerDetails[] = [];
  legs: be.Reservation[] = [];
  payment: be.Payment = {};
  profiles: be.Profiles = {};
  roundtrip?: boolean;
  savedCreditCard?: be.TokenizedCreditCard;
  serviceArea?: number;
  serviceAreaName?: string;
  totalOriginal: number = 0;

  constructor(booking?: Partial<be.Booking>) {
    if (booking) {
      this.contactInfo = booking.contactInfo || {};
      this.creditCards = booking.creditCards || [];
      this.edit = !!booking.edit;
      this.flags = booking.flags || {};
      this.otherInfo = booking.otherInfo || {};
      this.passengerDetails = booking.passengerDetails || [];
      this.payment = booking.payment || {};
      this.profiles = booking.profiles || {};
      this.legs = booking.legs || [];
      this.roundtrip = booking.roundtrip === undefined ? undefined : !!booking.roundtrip;
      this.itineraryId = booking.itineraryId || "";
      this.error = booking.error || "";
      this.savedCreditCard = booking.savedCreditCard;
      this.serviceArea = booking.serviceArea;
      this.serviceAreaName = booking.serviceAreaName;
      this.totalOriginal = booking.totalOriginal || 0;
    }
  }

  activeLegs() {
    if (this.legs.length == 0) return [];
    return this.roundtrip ? this.legs : [this.legs[0]];
  }

  // Returns true if there are legs with undefined fares.
  hasIncompleteTotal() {
    return this.activeLegs().some((leg) => leg.service && leg.service?.fareDisplay === undefined);
  }

  newVariance() {
    return -Math.abs(this.previouslyPaid()) + this.total();
  }

  total() {
    return this.legs.reduce((acc, leg) => acc + (leg.service?.fareDisplay || 0), 0);
  }

  originalTotal() {
    return Number(this.totalOriginal);
  }

  originalVariance() {
    return Number(this.payment?.variance);
  }

  previouslyPaid() {
    return this.originalTotal() - this.originalVariance();
  }

  showGrossOnly() {
    return this.legs.some((l) => l.service?.fareDisplayMode == "gross_only");
  }
}
